import { render, staticRenderFns } from "./ed-spinner.vue?vue&type=template&id=ab51ef5e&scoped=true&"
import script from "./ed-spinner.ts?vue&type=script&lang=js&"
export * from "./ed-spinner.ts?vue&type=script&lang=js&"
import style0 from "./ed-spinner.scss?vue&type=style&index=0&id=ab51ef5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab51ef5e",
  null
  
)

export default component.exports